export default {
    fields: {
        name: "Name",
        duration: "Dauer",
        firstName: "Vorname",
        lastName: "Nachname",
        email: "Email",
        confirmationEmail: "Adresse e-mail du client",
        phone: "Telefon",
        minimalAdvancedHours: "Mindestvorlauf",
        lockReservationsForTodayAt: "Termine für heute sperren ab",
        lockReservationsForTomorrowAt: "Termine für morgen sperren ab",
        minimalAdvancedDays: "Minimum Tage im Voraus",
        slotStep: "slot step-15",
    },
    c: {
        minutes: "Minuten",
        hours: "Stunden",
        hours00: ":00",
        oclock: "Uhr",
        days: "Tage",
        municipality: "Gemeinde",
    },
    error: "Etwas ist schiefgelaufen:(",
    login: {
        submit: "Login",
        username: "Benutzername",
        password: "Passwort",
        register: "Registrieren",
        errors: {
            credentials: "Benutzername oder Passwort falsch",
        },
    },
    register: {
        success: "Erfolgreich registiert",
        errors: {
            rejected: "Fehler bei der Registrierung",
        },
    },
    registerForm: {
        email: "Email",
        password: "Passwort",
        confirmPassword: "Passwort wiederholen",
        back: "Zurück",
        submit: "Registrieren",
    },
    lastMinute: {
        address: "Adresse",
        contact: "Ihre E-Mail",
        book: "Einen Termin verabreden",
        error: "Keine Termine",
        booked: "Vielen Dank! Termin gebucht",
        customeurl: "Benutzerdefinierte Weiterleitungs-URL"
    },
    business: {
        dashboard: {
            title: "Übersicht",
            today: "Termine am",
            todaytable: {
                date: "Datum",
                time: "Zeit",
                duration: "Dauer",
                customer: "Kunde",
                offers: "Dienstleistungen",
            },
            employeestoday: {
                header: "",
            },
            customerstoday: {
                header: "",
            },
            table: {
                nodata: "Heute keine Termine",
            },
        },
        tabs: {
            dashboard: "Übersicht",
            schedule: "Agenda",
            holidays: "Feiertage/Ferien",
            open: "Wochenplan",
            exceptions: "Ausnahmen",
            offers: "Angebot",
            settings: "Einstellungen",
            customers: "Kunden",
        },
        sidebar: {
            dashboard: "Startseite",
            business: "Administration",
            customers: "Kunden",
            appointments: "Alle Termine",
            logs: "Historie",
            newappointment: "Neuer Termin",
            offers: "Angebot",
            time: "Öffnungszeiten",
            integration: "Externer Kalender",
            events: "Protokoll",
        },
        holidays: {
            form: {
                name: "Name des Feiertags",
                header: {
                    new: "Neuer Feiertag",
                    edit: "Feiertag bearbeiten",
                },
                from: {
                    label: "Datum",
                    placeholder: "Datum des Feiertages",
                },
                to: {
                    label: "bis am",
                    placeholder: "Ende der Feiertage",
                },
                period: "Zeitraum",
                update: "aktualisieren",
                delete: "löschen",
                create: "speichern",
                cancel: "abbrechen",
            },
            table: {
                addholiday: {
                    button: "Feiertag hinzufügen",
                },
                name: "Name",
                from: "von",
                to: "bis",
                nodata: "keine Feiertage",
            },
            import: {
                delete: {
                    message: "Möchten Sie wirklich alle importierten Feiertage löschen?",
                },
            },
        },
        exceptions: {
            add: "Ausnahme hinzufügen",
            addhours: "Zeitraum hinzufügen",
            save: "Speichern",
            cancel: "abbrechen",
            delete: "Löschen",
            edit: "Bearbeiten",
        },
        offers: {
            add: {
                offer: "Angebot hinzufügen",
                duration: "Dauer hinzufügen",
            },
            drop: {
                duration: "Dauer entfernen",
            },
            offer: {
                offer: "Angebot",
                name: "Name des Angebotes",
                internal: "Interner Name des Angebotes",
                pre: "Vorlaufzeit",
                duration: "Dauer",
                post: "Nachlaufzeit",
                active: "aktiv",
            },
            create: "Angebot hinzufügen",
            update: "Angebot speichern",
            cancel: "Abbrechen",
            delete: "Angebot löschen",
        },
        settings: {
            tab: {
                business: "Geschäft",
                lastMinute: "Letzte Minute",
                rules: "Grundregeln",
                integrations: "Integrationen",
                display: "Anzeige",
            },
            notifications: {
                tab: "Benachrichtigungen",
                event: "Ereignis",
                customer: "Kunde",
                employee: "Mitarbeiter",
                business: "Geschäft",
                save: "Speichern",
                saved: "Benachrichtigungen gespeichert",
                events: {
                    CUSTOMER_REQUEST: "Kunde: Anfrage",
                    CUSTOMER_CONFIRMATION: "Kunde: Bestätigung",
                    CUSTOMER_CANCELLATION: "Kunde: Storno",
                    CUSTOMER_MESSAGE: "Kunde: Nachricht",
                    USER_NEW_APPOINTMENT: "Benutzer: Neuer Termin",
                    USER_CANCELLATION: "Benutzer: Storno",
                    SYSTEM_MISSING_CONFIRMATION: "System: fehlende Bestätigung",
                },
            },
            display: {
                hours: "Angezeigte Stunden",
                from: "von",
                to: "bis",
            },
            colors: {
                external: "Externe Termine",
                unconfirmed: "Unbestätigte Termine",
                confirmed: "Bestätigte Termine",
                holidays: "Ferien und Feiertage",
                update: "Farbeinstellungen erfolgreich aktualisiert",
            },
            business: {
                name: "Firmenname",
                logo: "Firmenlogo",
                changeLogo: "Logo ändern",
                address: "Firmenanschrift",
                email: "Email der Firma",
                mobile: "Mobile der Firma",
                notifyEmail: "per Email benachrichtigen",
                update: "Die Geschäftseinstellungen wurden erfolgreich aktualisiert",
            },
            lastMinute: {
                enable: "Last-Minute-Seite aktivieren",
                page: "Last Minute Seite",
                text: "Text",
                appointments: "Anzahl der Last-Minute-Termine",
                submit: "Seite senden",
                submitted: "Last Minute Seite aktualisiert",
            },
            notify: "benachrichtigen",
            email: {
                invalid: "Die Email Adresse ist ungültig",
            },
            update: "Speichern",
            owner: {
                name: "Leitung Name",
                email: "Leitung Email",
                mobile: "Leitung Mobile",
                notify: "benachrichtigen",
            },
            integration: {
                name: "Integrationen",
                provider: "Anbieter",
                profile: "Email-Konto",
                action: "Aktion",
                delete: "löschen",
                addcalendar: "Kalender anbinden",
                calendar: {
                    title: "Kalender für Synchronisierung",
                    current: "Aktuelle Auswahl",
                    target: "Zielkalender",
                    readonly: "(schreibgeschützt)",
                    none: "Keine Kalender vorhanden",
                    stale: "Auswahl nicht mehr vorhanden",
                    notActive: "Nur das aktive Profil synchronisiert; Auswahl deaktiviert",
                    preview: "Vorschau",
                    execute: "Kalender wechseln",
                    toMove: "randevu-bound Buchungen zu verschieben",
                    alreadyOnTarget: "randevu-bound bereits am Ziel",
                    toDrop: "remote-bound Einträge lokal zu entfernen",
                    manualReview: "Manuelle Prüfung nötig",
                    switched: "Kalender erfolgreich gewechselt",
                    confirm: "Kalender jetzt wechseln?",
                    failures: "Fehlgeschlagene Zeilen",
                    statusActive: "Synchronisierung aktiv",
                    statusPaused: "Synchronisierung pausiert",
                    statusInactive: "Nicht synchronisiert",
                },
            },
            hours: {
                hoursadvance: "Buchung min. Stunden vorher",
                daysahead: "Buchung max. Tage im Voraus",
                locktomorrow: "Buchungen für Folgetag sperren ab",
                locktoday: "Buchungen für heute sperren ab",
                slotstep: "Terminbeginn alle x Minuten",
                update: "Stunden erfolgreich aktualisiert",
                error: "Von Stunde muss weniger als bis Stunde sein",
            },
            booking: {
                url: "Adresse für Onlinebuchungen",
                copy: "kopieren",
                goto: "Öffnen",
            },
        },
        newappt: {
            firstName: {
                label: "Vorname",
            },
            lastName: {
                label: "Nachname",
            },
            email: {
                label: "Email",
            },
            phone: {
                label: "Telefon",
            },
            comment: {
                label: "Kommentar",
            },
            appointment: {
                create: "Enregistrer le rendez-vous",
                cancel: "annuler",
                confirm: "enregistrer",
                delete: "rejeter",
            },
            confirmation: {
                title: "Envoyer une confirmation ?",
                saved: "Le rendez-vous a été enregistré",
                send: "Envoyer",
                finish: "Terminer",
                queued: "La confirmation va être envoyée",
                failed: "Rendez-vous enregistré, mais la confirmation n'a pas pu être envoyée",
            },
            errors: {
                taken: "Ce rendez-vous est déjà pris",
                booking: "Le rendez-vous n'a pas pu être enregistré",
            },
            offers: {
                nodata: "Keine Angebote",
            },
        },
        import: {
            cleanup: {
                header: "importierte Feiertage löschen",
            },
            header: "Feiertage importieren",
            submit: "importieren",
            delete: "importierte löschen",
        },
        open: {
            title: "Öffnungszeiten",
            edit: "Bearbeiten",
            save: "Speichern",
            delete: "Löschen",
            cancel: "Abbrechen",
        },
        time: {
            tabs: {
                overview: "Übersicht",
            },
        },
        events: {
            loadmore: "mehr laden...",
        },
        integration: {
            tabs: {
                calendar: "Kalender",
            },
        },
    },

    help: {
        business: {
            dashboard: {
                todaylist: {
                    title: "Übersicht der Termine",
                    text: "Hier finden Sie eine Übersicht der heutigen Termine",
                },
            },
        },
    },

    exceptions: {
        title: "Ausnahmen",
    },
    customer: {
        table: {
            lastName: "Nachname",
            firstName: "Vorname",
            email: "Email",
            phone: "Telefon",
            appointments: "Termine",
            nodata: "keine Kunden",
        },
    },

    header: {
        menu: {
            logout: "logout",
        },
    },

    appointments: {
        label: "Alle Termine",
        update: "Speichern",
        notification: {
            updatesuccess: "Termin wird erfolgreich aktualisiert",
            updateerror: "Termin wird nicht aktualisiert, bitte erneut versuchen",
        },
        table: {
            nodata: "Keine Termine",
            time: "Termine",
            name: "Name",
            duration: "Dauer",
            notes: "Anmerkungen",
            action: "Aktion",
            source: "Quelle",
            offers: "Dienstleistungen",
            delete: "löschen",
            edit: "Bearbeiten",
            rndBound: "Réservation",
            calBound: "Agenda",
            managedInCalendar: "Im verbundenen Kalender ändern",
            notconfirmed: "nicht bestätigt"
        },
        dialog: {
            delete: {
                title: "Termin löschen",
                message:
                    "Sind Sie sicher, dass Sie diesen Termin <b>löschen</b> wollen?",
                cancel: "Abbrechen",
                confirm: "Termin löschen",
                done: "Termin gelöscht",
            },
        },
        noCalendar: {
            button: "Kein Kalender verbunden",
            title: "Kein Kalender verbunden",
            message: "verbliebene Einträge von externem Kalender in randevu löschen?",
            confirm: "Ja",
            cancel: "Nein",
            done: "Einträge gelöscht",
        },
    },

    admin: {
        test: {
            label: "Admin Test",
        },
        sidebar: {
            test: "Admin Test",
            dashboard: "Dashboard",
            api: "APIs",
            import: "Import",
            calendarSync: "Synchronisation calendrier",
        },
        calendarSync: {
            eyebrow: "Exploitation / Synchronisation calendrier",
            title: "Synchronisation des calendriers",
            intro: "Connexions, calendriers effectifs et éléments synchronisés pour tous les comptes.",
            refresh: "Actualiser",
            accounts: "Comptes",
            configured: "avec fournisseur",
            attention: "À vérifier",
            attentionHint: "Configuration ou métadonnées",
            activeUp: "UP actifs",
            activeDown: "DOWN actifs",
            allTime: "Total",
            search: "Rechercher compte, e-mail ou calendrier",
            allProviders: "Tous les fournisseurs",
            onlyAttention: "À vérifier uniquement",
            updated: "Mis à jour",
            id: "ID",
            account: "Compte",
            providerLabel: "Fournisseur",
            calendar: "Calendrier",
            readOnly: "Lecture seule",
            status: "Statut",
            active: "Actif",
            profiles: "Profils actifs / total",
            empty: "Aucun compte correspondant",
            upDefinition: "UP : réservations Randevu chez le fournisseur",
            downDefinition: "DOWN : éléments du fournisseur dans Randevu",
            activeDefinition: "Actif : futur et non supprimé",
            metadataPending: "Métadonnées en attente",
            readiness: {
                notReady: "Non prêt pour la synchronisation",
                noCalendars: "Aucun calendrier trouvé",
                emptyAccountContext: "Compte {provider} autorisé · {count} calendrier(s) trouvé(s)",
                emptyAccountAction: "Créer ou partager un calendrier, ou reconnecter le bon compte",
            },
            loadError: "Impossible de charger la vue de synchronisation",
            loading: "Chargement de la vue de synchronisation",
            unavailable: "Les données de synchronisation sont indisponibles pour le moment",
            retry: "Réessayer",
            lastVerified: "Dernière vérification",
            actions: "Actions",
            diagnose: "Diagnostiquer",
            disconnect: "Déconnecter",
            reconnect: "Reconnecter",
            disconnectPreview: "Aperçu de la déconnexion",
            confirmDisconnect: "Confirmer la déconnexion",
            disconnectSucceeded: "Connexion déconnectée en toute sécurité",
            reasonRequired: "Saisir un motif opérateur traçable",
            createAuthorization: "Créer le lien d’autorisation",
            reconnectPending: "Autorisation client en attente",
            customerMustAuthorize: "Le client doit autoriser l’accès fournisseur avec le lien",
            customerAuthorization: "Ouvrir le lien d’autorisation",
            checkReconnect: "Vérifier le statut",
            selectCalendar: "Choisir un calendrier inscriptible",
            activateReplacement: "Activer le remplacement",
            confirmIdentityChange: "Vérifier l’identité du fournisseur et le calendrier avant d’activer le remplacement",
            replacementActivated: "Remplacement activé; l’ancienne connexion est conservée jusqu’au contrôle de santé",
            operationFailed: "Échec de l’opération",
            health: {
                OK: "Synchronisation saine",
                EMPTY_ACCOUNT: "Compte sans calendrier",
                TOKEN_INVALID: "Autorisation invalide",
                NO_WRITABLE_CALENDAR: "Aucun calendrier inscriptible",
                SELECTION_STALE: "Sélection obsolète",
                PROVIDER_UNAVAILABLE: "Fournisseur indisponible",
                UNKNOWN_ERROR: "Statut inconnu",
                JOB_NOT_RUNNING: "Tâche de synchronisation inactive",
            },
            provider: {
                NONE: "Aucun",
                UNKNOWN: "Inconnu",
            },
            states: {
                NONE: "Non connecté",
                CONNECTED: "Connecté",
                TOKEN_MISSING: "Jeton manquant",
                DISABLED: "Désactivé",
                READ_ONLY: "Lecture seule",
            },
            calendarTypes: {
                NONE: "Aucun calendrier",
                MAIN: "Calendrier principal",
                SUBCALENDAR: "Sous-calendrier",
                UNKNOWN: "Type inconnu",
            },
            warnings: {
                SYNC_DISABLED: "Synchronisation désactivée",
                TOKEN_MISSING: "Jeton manquant",
                CALENDAR_READ_ONLY: "Calendrier en lecture seule",
                MULTIPLE_ACTIVE_PROFILES: "Plusieurs profils actifs",
                UNKNOWN_PROVIDER: "Fournisseur inconnu",
                CALENDAR_METADATA_PENDING: "Métadonnées en attente",
                CALENDAR_SELECTION_STALE: "Sélection obsolète",
                HEALTH_SNAPSHOT_PENDING: "État de santé en attente",
                JOB_NOT_RUNNING: "Tâche de synchronisation inactive",
                EMPTY_ACCOUNT: "Compte sans calendrier",
                TOKEN_INVALID: "Autorisation invalide",
                NO_WRITABLE_CALENDAR: "Aucun calendrier inscriptible",
                SELECTION_STALE: "Sélection obsolète",
                PROVIDER_UNAVAILABLE: "Fournisseur indisponible",
                UNKNOWN_ERROR: "Statut inconnu",
            },
        },
    },

    logs: {
        label: "Historie",
    },

    validation: {
        timeformat: "Format hh:mm",
        phoneformat: "Telefonnummer unvollständig oder ungültig",
        timeoverlap: {
            from: "",
            to: "kein gültiger Zeitraum",
            required: "Eingabe erforderlich",
        },
    },

    booking: {
        steps: [
            {
                title: "Personalien"
            },
            {
                title: "Termin"
            },
            {
                title: "Buchen"
            },
            {
                title: "Bestätigung"
            },
        ],
        profile: {
            header: "Personalien",
            step: "Personalien",
            firstName: "Vorname",
            lastName: "Nachname",
            email: "Email",
            phone: "Telefon",
            continue: "Weiter",
            comment: "Kommentar",
        },
        appointment: {
            book: "Definitiv buchen",
            step: "Termin",
            errors: {
                noslot: "Keine freien Termine",
            },
            header: {
                offer: "Wählen Sie Ihren Termin",
                book: "Termin buchen",
                date: "Datum",
                duration: "Dauer",
                service: "Behandlung",
                time: "Zeit",
                summary: "Ihr Termin",
            },
        },
        finish: {
            step: "Fertig",
            thanks: "Danke für Ihre Buchung",
        },
        confirm: {
            confirm: "Bitte bestätigen",
            link: "Wir haben Ihnen einen Link zur Bestätigung an folgende Adresse gesendet:",
            finish: "Bitte klicken Sie in der Email auf den Link, um die Buchung zu bestätigen.",
            progress1a: "Danke für Ihre Anfrage.",
            progress1b: "Der Termin wurde noch nicht gebucht.",
            progress2a: "Danke für die Bestätigung.",
            progress2b: "Ihr Termin ist reserviert.",
            thanks1: "Danke für die Bestätigung. Der Termin ist gebucht.",
            thanks2: "Sie erhalten eine Bestätigung per Email",
            step: "Bestätigung",
        },
    },
};



// WEBPACK FOOTER //
// ./src/i18n/i18n-fr.js